
import React, { useEffect, useState } from "react";

import { 
  TableRow, 
  TableCell, 
  Box, 
  Typography, 
  Avatar, 
  Button
} from "@mui/material";
import CustomCheckbox from "./CustomCheckbox";  
import ManualActivityBar from "./ManualActivityBar";
import Reason from '../../../components/Projects/Reason';

const cellStyle = {
  padding: '10px 16px',
};

const getInitials = (name) => {
  const names = name.split(" ");
  return names.map(n => n[0]).join("").toUpperCase();
};

const stringToColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = `hsl(${hash % 360}, 60%, 60%)`;
  return color;
};


const ManualRow = ({ row, isSelected, onSelectToggle, isMeView = false, isAllView = false }) => {
  const [openReason, setOpenReason] = useState(false);
  return (
    <TableRow sx={{
      '&:hover': { boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)' },
      backgroundColor: '#fff',
      borderRadius: '10px',
      transition: 'box-shadow 0.3s ease',
    }}>
      <TableCell sx={{ 
        ...cellStyle, 
        border: 'none', 
        minWidth: '32px', 
        maxWidth: '32px',
        borderRadius: '10px 0 0 10px',
      }}>
        <CustomCheckbox checked={isSelected} onChange={onSelectToggle} />
      </TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none' }}>
        {row.id}
      </TableCell>

     {!isMeView && ( <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'left' }}>
  <Box display="flex" alignItems="center" gap={1}>
    <Avatar src={row.avatar} sx={{ width: '40px', height: '40px', fontSize: '13px' }} />
    <Box>
      <Typography fontWeight="bold" sx={{whiteSpace:'nowrap'}}>{row.name}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{whiteSpace:'nowrap'}}>
        {row.role}
      </Typography>
    </Box>
  </Box>
</TableCell>)}


     {!isAllView && ( <TableCell sx={{
  ...cellStyle,
  border: 'none',
  color: '#626262',
  backgroundColor: '#fff',
  textAlign: 'left'
}}>
  <Box display="flex" alignItems="center" gap={1}>
    <Avatar
      sx={{
        width: '40px',
        height: '40px',
        fontSize: '13px',
        bgcolor: stringToColor(row.projectName),
      }}
    >
      {getInitials(row.projectName)}
    </Avatar>
    <Box>
      <Typography fontWeight="bold" sx={{whiteSpace:'nowrap'}}>{row.projectName}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{whiteSpace:'nowrap'}}>
        {row.projectRole}
      </Typography>
    </Box>
  </Box>
</TableCell>  )}



      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
  {row.action === "Add" ? (
    <Button sx={{background:'#27AE60', color:'#fff', fontSize:'13px', textTransform:'capitalize'}}>
      Add
    </Button>
  ) : (
    <Button sx={{background:'#F4413D', color:'#fff', fontSize:'13px', textTransform:'capitalize'}}>
      Delete
    </Button>
  )}
</TableCell>

      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'left' }}>
  <Box display="flex" alignItems="center" gap={1}>
    <Avatar src={row.changedByavatar} sx={{ width: '40px', height: '40px', fontSize: '13px' }} />
    <Box>
      <Typography fontWeight="bold" sx={{whiteSpace:'nowrap'}}>{row.changedByName}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{whiteSpace:'nowrap'}}>
        {row.changedByRole}
      </Typography>
    </Box>
  </Box>
</TableCell>
      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        {row.changedAt}
      </TableCell>
      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
       <Typography variant="body2" color="text.secondary" sx={{whiteSpace:'nowrap'}}>{row.dateDay}</Typography>
       <Typography variant="body2" color="text.secondary" sx={{whiteSpace:'nowrap'}}>{row.time}</Typography>
        
      </TableCell>
      <TableCell sx={{ ...cellStyle, border: 'none', textAlign: 'center' }}>
        {row.timeChange}
      </TableCell>
        

      <TableCell sx={{ 
        ...cellStyle, 
        border: 'none', 
        textAlign: 'center',
        borderRadius: '0px 10px 10px 0px' 
      }}>
        <Typography color="primary" onClick={() => setOpenReason(true)} sx={{ cursor: "pointer" }}>
         view
        </Typography>
      </TableCell>

 <Reason open={openReason} onClose={() => setOpenReason(false)} />
    </TableRow>
  );
};

export default ManualRow;
